import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Download, Lock, Award } from 'lucide-react';
const CHECKOUT_URL = 'https://noveliahub.com/cart/50875095482404:1';
export function FinalCTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const handleCheckout = () => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout');
    }
  };
  return <section ref={ref} className="w-full bg-gradient-to-b from-white to-orange-100 py-16 md:py-24" data-id="element-53">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-55">
          <h2 className="font-fredoka text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-1" data-id="element-56">
            No esperes más...
          </h2>
          <p className="font-nunito text-lg sm:text-xl text-gray-500 italic mb-6" data-id="element-57">
            Don't wait any longer...
          </p>

          <p className="font-nunito text-xl sm:text-2xl text-gray-700 leading-relaxed" data-id="element-58">
            Cada día frente a la pantalla es un día menos de desarrollo
            creativo.
          </p>
          <p className="font-nunito text-base sm:text-lg text-gray-500 italic mb-6 mt-1" data-id="element-59">
            Every day on a screen is one less day of creative development.
          </p>

          <p className="font-fredoka text-2xl sm:text-3xl font-bold text-orange-600 mb-1" data-id="element-60">
            Hoy puedes cambiarlo por solo $6.36
          </p>
          <p className="font-nunito text-base sm:text-lg text-orange-400 italic mb-8" data-id="element-61">
            You can change it today for only $6.36
          </p>

          <motion.a href={CHECKOUT_URL} onClick={handleCheckout} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="bg-orange-500 hover:bg-orange-600 text-white font-fredoka font-bold text-xl sm:text-2xl px-12 py-6 rounded-full shadow-lg hover:shadow-xl transition-all mb-8 inline-block" data-id="element-62">
            COMPRAR AHORA / BUY NOW — $6.36
          </motion.a>

          <div className="flex flex-wrap justify-center gap-8 text-sm sm:text-base" data-id="element-63">
            <div className="flex flex-col items-center text-gray-700" data-id="element-64">
              <div className="flex items-center gap-2" data-id="element-65">
                <Download className="w-5 h-5 text-orange-600" data-id="element-66" />
                <span className="font-nunito font-semibold" data-id="element-67">
                  Descarga instantánea
                </span>
              </div>
              <span className="font-nunito text-xs sm:text-sm text-gray-500 italic mt-0.5" data-id="element-68">
                Instant download
              </span>
            </div>
            <div className="flex flex-col items-center text-gray-700" data-id="element-69">
              <div className="flex items-center gap-2" data-id="element-70">
                <Lock className="w-5 h-5 text-orange-600" data-id="element-71" />
                <span className="font-nunito font-semibold" data-id="element-72">Pago seguro</span>
              </div>
              <span className="font-nunito text-xs sm:text-sm text-gray-500 italic mt-0.5" data-id="element-73">
                Secure payment
              </span>
            </div>
            <div className="flex flex-col items-center text-gray-700" data-id="element-74">
              <div className="flex items-center gap-2" data-id="element-75">
                <Award className="w-5 h-5 text-orange-600" data-id="element-76" />
                <span className="font-nunito font-semibold" data-id="element-77">
                  Garantía 30 días
                </span>
              </div>
              <span className="font-nunito text-xs sm:text-sm text-gray-500 italic mt-0.5" data-id="element-78">
                30-day guarantee
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}